
function initHomeHero() {
	

	// Wait until the DOM is ready
	document.addEventListener('DOMContentLoaded', function() {

		// VIDEO CONTROLS
		const videos = document.querySelectorAll('.video-background');
		const pauseButtons = document.querySelectorAll('.pause-button');

		pauseButtons.forEach(function(pauseButton, index) {
			const video = videos[index];
			const pauseSpan = pauseButton.querySelector('.pause');
			const playSpan = pauseButton.querySelector('.play');

			pauseButton.addEventListener('click', function() {
				if (video.paused) {
					video.play();
					playSpan.style.display = 'none';
					pauseSpan.style.display = 'flex';
				} else {
					video.pause();
					pauseSpan.style.display = 'none';
					playSpan.style.display = 'flex';
				}
			});
		});

		
	});
}

initHomeHero();

export default initHomeHero;